import React, { Component } from 'react';
import './editalumni.css';
import { Input, Modal, Button, Tabs, Row, Col, Spin, Empty, Icon, Alert, Collapse, Form, Select, DatePicker, Checkbox, Tree } from 'antd';
import moment from 'moment';
import * as actions from '../../actions/index';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask'
import { withRouter } from 'react-router-dom';
import warningAlert from "../BulkUpload/warning-alert.png";
import { each } from 'lodash';
import NESAAddMembership from './NESAAddMembership';




const FormItem = Form.Item;
const Option = Select.Option;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />
const NESA_MID = process.env.REACT_APP_NESA_MID;
class NESAReg extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...props,
            needToUpdate: [],
            visibleExpiryModal: false,
            visibleOtherReason: false,
            ReasonToExpire: '',
            forShowingInScoutingAffiliationFrame: false,
            isShowUpdateMembershipModal: false,
            registrationId: '',
            personPositionId: '',
            membershipIndex: undefined,
            membershipFormValues: undefined,
            expireMemberships_DefaultEffDate: undefined,
            expireMemberships_DefaultExpDate: undefined,
            expiringMembershipProgramId: undefined
        }
    }

    componentDidMount = () => {
        this.props.actions.getNESAmembershiplevels()
        const { pathname } = this.props.location;
        console.log('location.pathname ', pathname);
        (pathname === '/my-profile' || pathname === '/manage-memberid' || pathname === '/alumni-dashboard') ? this.setState({
            forShowingInScoutingAffiliationFrame: true
        }) : null
    }
    componentWillReceiveProps = (nextprops) => {
        if (!nextprops.expiring_membership && nextprops.expiring_membership != this.props.expiring_membership) {
            this.closeExpiryMembershipModal()
        }
        if (nextprops.nesa_reg_updated) {
            this.setState({
                needToUpdate: []
            })
        }
        if(nextprops.nesa_reg){
            let curDate = new Date();
            const isActiveLifetimeMembership = nextprops.nesa_reg.find(reg => reg.programId == 32 && moment(curDate).isSameOrAfter(reg.effectiveDate) && (reg.expireDate == null 
                // || moment(curDate).isSameOrBefore(reg.expireDate)
                ))
                isActiveLifetimeMembership ? this.setState({
                    isActiveLifetimeMembership: true,
                    activeLifetimeMembership : isActiveLifetimeMembership
                }) : this.setState({
                    isActiveLifetimeMembership: false,
                    activeLifetimeMembership : {}
                })
        }
    }

    renderNesaLevels = () => {
        if (this.props.nesa_levels) {
            let nesalevels = this.props.nesa_levels
            return nesalevels.map((k, index) => {
                return <Option value={k.id}>{(k.name).replace(/-/g, " ")}</Option>
            })
        }
    }

    handleNESASubmit = (jIndex, e, membership) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({
                    membershipFormValues: values,
                    membershipIndex: jIndex
                })
                membership.programId.toString() === '32' && !this.state.needToUpdate[jIndex].isOverlaps ? this.props.actions.UpdateMembership(this.props.personGUID, membership.registrationId, this.state.needToUpdate[jIndex].updatedEffectiveDate, null, "NESA") :
                    this.showUpdateMembershipModal()
            }
        })
    }
    // handleUpdateMembership = () => {
    //     const values = this.state.membershipFormValues;
    //     let effDate = this.state.needToUpdate[this.state.membershipIndex].expectedEffectiveDate ? this.state.needToUpdate[this.state.membershipIndex].expectedEffectiveDate : values['nesa_effective_date' + [this.state.membershipIndex]]
    //     let  expDate=  this.state.needToUpdate[this.state.membershipIndex].expectedExpirationDate ? this.state.needToUpdate[this.state.membershipIndex].expectedExpirationDate : values['nesa_expire_date' + [this.state.membershipIndex]]
    //     this.props.actions.UpdateMembership(this.props.personGUID, values['registrationId' + [this.state.membershipIndex]], effDate, expDate, "NESA")
    //     this.setState({isShowUpdateMembershipModal:false})
    // }

    closeExpiryMembershipModal = () => {
        this.props.form.resetFields(['expiry_reason', 'other_reason']);
        this.setState({
             visibleExpiryModal: false,
             visibleOtherReason: false,
             expireMemberships_DefaultExpDate: undefined,
             expireMemberships_DefaultEffDate: undefined,
             registrationId: undefined,
             expiringMembershipProgramId: undefined
            })
    }

    handleExpiryMembership = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const { expireMemberships_DefaultExpDate, expireMemberships_DefaultEffDate, personPositionId, registrationId } = this.state;
                const currentDate = new Date();
                let tempEffectiveDate = moment(new Date()).add(1, 'day').format('YYYY-MM-DD');
                let selectedMembershipCalculatedExpDate = moment(new Date()).format('YYYY-MM-DD');
                let getSubsequentMembership = [];
                const nesaRegistrationRecords = [...this.props.nesa_reg];

const currentDateMoment = moment(currentDate);
let getSelectedMembership = false;

const processedMemberships = nesaRegistrationRecords.reverse().reduce((prevMembership, membership) => {
    const { registrationId: regId, effectiveDate: effDate, expireDate: expDate } = membership;
    const effDateMoment = moment(effDate);
    const expDateMoment = expDate ? moment(expDate) : null;

    // Check whether the selected membership is active or future membership
    if (regId === registrationId) {
        if (effDateMoment.isSameOrBefore(currentDateMoment) && expDateMoment && expDateMoment.isAfter(currentDateMoment)) {
            // If active, set its 'selectedMembershipCalculatedExpDate' as current date
            selectedMembershipCalculatedExpDate = currentDateMoment.format('YYYY-MM-DD');
            tempEffectiveDate = currentDateMoment.add(1, 'day').format('YYYY-MM-DD');
            getSelectedMembership = true;
        } else if (effDateMoment.isAfter(currentDateMoment)) {
            // If in future, set its 'selectedMembershipCalculatedExpDate' as its effective date
            selectedMembershipCalculatedExpDate = effDateMoment.format('YYYY-MM-DD');
            tempEffectiveDate = effDateMoment.add(1, 'day').format('YYYY-MM-DD');
            getSelectedMembership = true;
        }
    }

    // If selected membership was found and processing subsequent memberships
    else if (getSelectedMembership && effDate != null) {
        let calculatedExpireDate = expDate ? expDateMoment.diff(effDateMoment, 'days') : null;
        calculatedExpireDate = calculatedExpireDate >= 0 ? moment(tempEffectiveDate).add(calculatedExpireDate, 'days').format('YYYY-MM-DD') : expDate;
        
        getSubsequentMembership.push({
            susequantMembershipExpDate: expDate,
            susequantMembershipRegID: regId,
            calculatedEffectiveDate: tempEffectiveDate,
            calculatedExpireDate
        });
        tempEffectiveDate = moment(calculatedExpireDate).add(1, 'days').format('YYYY-MM-DD');
    }
    return membership
}, {});
console.log('processedMemberships', processedMemberships);


                // const getCurrentMembership = nesaRegistrationRecords.filter(eachMembership => {
                //     const currentDate = new Date();
                //     return moment(currentDate).isSameOrAfter(eachMembership.effectiveDate) && 
                //            (eachMembership.expireDate == null || moment(currentDate).isBefore(eachMembership.expireDate));
                // });
                // if(getCurrentMembership.length > 0){
                //     const isselectedMembershipActive = getCurrentMembership.find(membership => membership.registrationId === registrationId);
                //     // Check whether the selected membership is the current membership:
                //     // - If it is, set the `selectedMembershipCalculatedExpDate` to current date.
                //     if (isselectedMembershipActive) {
                //         selectedMembershipCalculatedExpDate = moment(new Date()).format('YYYY-MM-DD');
                //     }
                //     else { // - If it is not, set the `selectedMembershipCalculatedExpDate` to same as it's effective date.
                //         tempEffectiveDate = moment(expireMemberships_DefaultEffDate).add(1, 'day').format('YYYY-MM-DD');
                //         selectedMembershipCalculatedExpDate = expireMemberships_DefaultEffDate;
                //     } 
                // }
                // else {
                //     tempEffectiveDate = moment(expireMemberships_DefaultEffDate).add(1, 'day').format('YYYY-MM-DD');
                //     selectedMembershipCalculatedExpDate = expireMemberships_DefaultEffDate;
                // }
                
                // nesaRegistrationRecords.sort((a, b) => moment(a.expireDate).diff(moment(b.expireDate)));
                // nesaRegistrationRecords.forEach(membership => {
                //     //NOTE: If membership has the same effective and expiration date, we consider it an "EXPIRED" membership
                //     //Check if any subsequent memberships have the same effective and expirationDate.
                //     //If yes, set its effective and expiration date for the next day of the previous membership's expiration date.
                //     if (membership.registrationId !== registrationId && moment(membership.effectiveDate).isSame(membership.expireDate)) {
                //         getSubsequentMembership.push({
                //             susequantMembershipExpDate: membership.expireDate,
                //             susequantMembershipRegID: membership.registrationId,
                //             calculatedEffectiveDate: tempEffectiveDate,
                //             calculatedExpireDate: tempEffectiveDate
                //         });
                //         tempEffectiveDate = moment(tempEffectiveDate).add(1, 'days').format('YYYY-MM-DD');
                //     }
                //     if (membership.registrationId !== registrationId 
                //         && (moment(membership.expireDate).isSameOrAfter(expireMemberships_DefaultExpDate) || (membership.programId === 32 && membership.expireDate == null))) {                    
                //         let calculate_ExpireDate;
                //         if (membership.programId === 32) { //If the lifetime membership does not have an expiration date, there is no need to set one.
                //             if (membership.expireDate == null) 
                //                 calculate_ExpireDate = null;
                //              else {
                //                 // Calculate the difference in days
                //                 let spanInDays = membership.expireDate.diff(membership.effectiveDate, 'days');
                //                 calculate_ExpireDate = moment(tempEffectiveDate).add(spanInDays, 'days').format('YYYY-MM-DD');
                //              }
                //         } else { //membership.programId === 30 
                //             calculate_ExpireDate = moment(tempEffectiveDate).add(5, 'years').subtract(1, 'day');
                //         }
                //         getSubsequentMembership.push({ 
                //             susequantMembershipExpDate: membership.expireDate,
                //             susequantMembershipRegID: membership.registrationId,
                //             calculatedEffectiveDate: tempEffectiveDate,
                //             calculatedExpireDate: membership.programId === 30 ? moment(tempEffectiveDate).add(5, 'years').subtract(1, 'day').format('YYYY-MM-DD') : ''
                //         });
                //         tempEffectiveDate = moment(tempEffectiveDate).add(5, 'years').format('YYYY-MM-DD');
                //     }
                // });
                
                // console.log('selectedMembershipCalculatedEffDate', selectedMembershipCalculatedEffDate);                
                console.log('selectedMembershipCalculatedExpDate', selectedMembershipCalculatedExpDate);                
                console.log('getSubsequentMembership', getSubsequentMembership);         
                this.props.actions.expiryMembership(registrationId, personPositionId, this.props.personGUID, values.expiry_reason, selectedMembershipCalculatedExpDate, getSubsequentMembership)       
            }
        })
    }

    ReasonChange = (value) => {
        if (value == 'Others') {
            this.setState({
                visibleOtherReason: true
            })
        } else {
            this.setState({
                visibleOtherReason: false
            })
        }
        this.setState({
            ReasonToExpire: value
        })
    }
    showUpdateMembershipModal = () => {
        this.setState({
            isShowUpdateMembershipModal: true
        })
    }

    checkOverlapRecord = (getRegistrationID, effectiveDate, expireDate) => {
        return this.props.nesa_reg.find(eachReg => {
            if (eachReg.registrationId !== getRegistrationID) {
                const effectiveStartsBeforeExpire = moment(effectiveDate).isSameOrBefore(eachReg.expireDate);
                const expireStartsAfterEffective = moment(expireDate).isSameOrAfter(eachReg.effectiveDate);

                if (effectiveStartsBeforeExpire && expireStartsAfterEffective) {
                    return true;
                }
            }
            return false;
        });
    };


    renderNESAForm = (jIndex, nesalevel_name, j) => {
        // Once an active Lifetime membership exists, every other membership is locked — only the Lifetime membership itself stays editable.
        const disableDueToActiveLifetime = this.hasActiveLifetimeMembership(this.props.nesa_reg) && j.programId != 32;
        let status = '';
        // const nesaRegistrations = this.props.nesa_reg;
        // const isActiveLifetimeMembership = nesaRegistrations.find(reg => j.programId == 32 && moment(curDate).isSameOrAfter(j.effectiveDate) && (j.expireDate == null || moment(curDate).isSameOrBefore(j.expireDate)))
        // isActiveLifetimeMembership ? this.setState({isActiveLifetimeMembership: true}) : ''
        let lapseDate = moment().subtract(2, 'months').format('YYYY-MM-DD');
        let curDate = moment().format('YYYY-MM-DD')
        // if ((isActiveLifetimeMembership || this.state.isActiveLifetimeMembership) && j.programId == 32 ) {
        //     status = 'active'
        // } else if((isActiveLifetimeMembership || this.state.isActiveLifetimeMembership) && j.programId == 30) {

        // }
        // else if (!(isActiveLifetimeMembership || this.state.isActiveLifetimeMembership)) {
            if (moment(j.effectiveDate).isSame(j.expireDate) ||  moment(j.expireDate).isBefore(lapseDate)) {
                status = "expiry" //If a membership has the same EffectiveDate and ExpireDate, we classify it as an "Expired" membership. 
                // as per the ticket AAG-925
            } else if(moment(curDate).isSameOrAfter(j.effectiveDate) && (j.expireDate == null || moment(curDate).isBefore(j.expireDate))) {
                (j.isUpgrade && j.programId == 32) ? status = 'upgrade' : status = 'active';
            } else if(moment(curDate).isBefore(j.effectiveDate)) {
                status = 'inactive'
            } else if(moment(j.expireDate).isSameOrAfter(lapseDate) && moment(j.expireDate).isSameOrBefore(curDate)) {
                status = 'lapsed'
            }
        // } 
       
        // if (nesaRegistrations.length == '1') { //1. Expire status is missing or not displayed after expiring a NESA Lifetime membership. Issue reported in AAG-907
        //     if (j.programId == 32 && ((j.expireDate == null || j.expireDate == "") && moment(j.effectiveDate) < moment.now())) {
        //         status = 'active'
        //     } else {
        //         if (moment(j.expireDate) > moment.now() && moment(j.effectiveDate) > moment.now()) {
        //             status = 'inactive'
        //         }
        //         if (moment(j.expireDate) < moment.now() && moment(j.effectiveDate) < moment.now()) {
        //             // status = 'expiry'
        //             if(j.programId == 30 && moment(j.effectiveDate) > moment.now() && moment(j.expireDate) > moment.now()) {
        //                 status = 'inactive'
        //             }else if (j.expireDate && moment(j.expireDate) < moment.now()) {
        //                 status = "expiry"
        //             }
        //         }
        //         if (expiryDate < curDate && curDate < lapseDate) {
        //             status = 'lapsed'
        //         }
        //         if (moment(j.expireDate) > moment.now() && moment(j.effectiveDate) < moment.now()) {
        //             status = 'active'
        //         }
        //     }
        // } else {
        //     // If a lifetime plan exists already then 5 year plan will be inactive
        //     let membershipPlans = [];
        //     nesaRegistrations.map((j, jIndex) => {
        //         let nesalevels = this.props.nesa_levels
        //         let nesa_name = ''
        //         nesalevels.map((k, index) => {
        //             if (k.id == j.programId) nesa_name = k.name
        //             membershipPlans.push(nesa_name)
        //         })
        //     })

        //     if (membershipPlans.includes("NESA-Lifetime") && membershipPlans.includes("NESA-5Year")) {
        //         if (j.programId == 32 && moment(j.effectiveDate) > moment.now()) {
        //             status = 'inactive'
        //         }
        //         else if (j.programId == 30 && moment(j.expireDate) > moment.now() && moment(j.effectiveDate) < moment.now()) {
        //             status = 'active'
        //         }
        //         else if (nesalevel_name === "NESA-5Year") {
        //             if(j.programId == 30 && moment(j.effectiveDate) > moment.now() && moment(j.expireDate) > moment.now()) {
        //                 status = 'inactive'
        //             }else if (j.expireDate && moment(j.expireDate) < moment.now()) {
        //                 status = "expiry"
        //             }
        //         } else if (nesalevel_name === "NESA-Lifetime") {
        //             if (j.isUpgrade) {
        //                 status = 'upgrade'
        //             } else {
        //                 status = 'active'
        //             }
        //         }
        //         else if ((!j.expireDate == null || !j.expireDate == "") || (j.expireDate) && moment(j.effectiveDate) > moment.now()) {
        //             let membershipYears = new Date(new Date(j.expireDate) - new Date(j.effectiveDate)).getFullYear() - 1970;
        //             if (membershipYears >= 99) status = 'active'
        //         }
        //     }
        //     else if (!membershipPlans.includes("NESA-Lifetime") && membershipPlans.includes("NESA-5Year")) {
        //         // Checking which plan has highest effective date
        //         if (moment(j.expireDate) > moment.now() && moment(j.effectiveDate) > moment.now()) {
        //             status = 'inactive'
        //         }
        //         if (moment(j.expireDate) < moment.now() && moment(j.effectiveDate) < moment.now()) {
        //             status = 'expiry'
        //         }
        //         if (moment(j.expireDate) > moment.now() && moment(j.effectiveDate) < moment.now()) {
        //             status = 'active'
        //         }
        //     }
        // }
        // if ((j.effectiveDate && !j.expireDate) && nesalevel_name === 'NESA-Lifetime') {
        //     if (j.isUpgrade) {
        //         status = 'upgrade'
        //     } else {
        //         status = 'active'
        //     }
        // }

        const CheckNeedsToUpdate = (date, jIndex, e, type, membership) => {
            // Initialize variables
            let updatedEffectiveDate = undefined;
            let updatedExpiryDate = undefined;
            let getRegistraionID = membership.registrationId; //Default Values
            let expectedEffectiveDate;
            let expectedExpirationDate = undefined;
            let defaultEffectiveDate = membership.effectiveDate; //Default Values
            let defaultExpirationDate = membership.expireDate; //Default Values
            let isOverlaps;
            let contentText = undefined;
            let modalPrimaryBtnText;
            let modalScondaryBtnText;
            let primaryBtnHandler;
            let secondaryBtnHandler;
            let isUpdatedEffectiveDate;
            let isUpdatedExpirationDate;
            let membershipTerm = membership.programId.toString() === '32' ? 'Lifetime' : '5-Year';

            // Clone the 'needToUpdate' array to avoid mutating the state directly
            let needToUpdate = [...this.state.needToUpdate];

            // Check if the type is 'effectiveDate' and the input value has a length of 10
            if (type === 'effectiveDate' && e.target.value.length === 10) {
                updatedEffectiveDate = e.target.value;
                // Commented out line: 'defaultExpirationDate = membership'
            } else if (type === 'expiryDate' && e.target.value.length === 10) {
                // Commented out line: 'defaultEffectiveDate = membership'
                updatedExpiryDate = e.target.value;
            }

            // Check if there are more than 1 items in 'nesa_reg' and the input value has a length of 10
            if (this.props.nesa_reg.length > 1 && e.target.value.length === 10) {
                // Prepare 'effectiveDate' and 'expireDate' based on 'type'
                let effectiveDate = type === 'effectiveDate' ? updatedEffectiveDate : defaultEffectiveDate;
                let expireDate = type === 'expiryDate' ? updatedExpiryDate : defaultExpirationDate;

                // Check for date overlaps in 'nesa_reg'
                this.props.nesa_reg.find(eachReg => {
                    if ((eachReg.registrationId != getRegistraionID) && (membershipTerm === 'Lifetime') &&
                        (moment(effectiveDate).isBefore(eachReg.expireDate))) {
                        return isOverlaps = true;
                    }
                    else if ((eachReg.registrationId != getRegistraionID) &&
                        (moment(effectiveDate).isSameOrAfter(eachReg.effectiveDate) && moment(effectiveDate).isBefore(eachReg.expireDate)) &&
                        (moment(expireDate).isSameOrAfter(eachReg.effectiveDate) && moment(expireDate).isBefore(eachReg.expireDate))) {
                        return isOverlaps = true;
                    }
                });
            }

            // Check if there are overlaps
            if (isOverlaps) {
                contentText = <p>The attempted date adjustment conflicts with an existing membership. Please review the other memberships for this member and make appropriate adjustments to avoid overlapping dates.</p>;
                modalPrimaryBtnText = 'Ok';
                modalScondaryBtnText = undefined;
                primaryBtnHandler = () => this.setState({ isShowUpdateMembershipModal: false });
                secondaryBtnHandler = undefined;
                isUpdatedEffectiveDate = true;

                // Update the 'needToUpdate' array
                needToUpdate[jIndex] = {
                    buttonNeedToUpdate: isUpdatedEffectiveDate,
                    isUpdatedEffectiveDate,
                    isUpdatedExpirationDate: needToUpdate[jIndex] ? needToUpdate[jIndex].isUpdatedExpirationDate : false,
                    expectedExpirationDate,
                    contentText,
                    modalPrimaryBtnText,
                    modalScondaryBtnText,
                    primaryBtnHandler,
                    secondaryBtnHandler,
                    isOverlaps
                };

                // Update the state with the modified 'needToUpdate' array
                this.setState({
                    needToUpdate: needToUpdate
                });
            }
            // Check if the 'type' is 'effectiveDate'
            else if (type === 'effectiveDate') {
                // Check if the effective date is different and has a length of 10
                if ((!moment(defaultEffectiveDate).isSame(e.target.value) && e.target.value.length === 10)) {
                    updatedEffectiveDate = moment(e.target.value).format('MM/DD/YYYY');
                    isUpdatedEffectiveDate = true;
                    if (membershipTerm === 'Lifetime') {
                        needToUpdate[jIndex] = {
                            buttonNeedToUpdate: true,
                            updatedEffectiveDate,
                            isOverlaps
                        }
                        this.setState({
                            needToUpdate: needToUpdate
                        });
                        return;
                    } else {
                        expectedExpirationDate = moment(e.target.value).add('years', 5).subtract('days', 1).format('MM/DD/YYYY');
                        contentText = <p>The expected expiration date for a 5-year membership that starts on <strong>{updatedEffectiveDate}</strong> is <strong>{moment(expectedExpirationDate).format('MM/DD/YYYY')}</strong>, Do you wish to update the expiration date accordingly?</p>;
                        modalPrimaryBtnText = 'Ok';
                        modalScondaryBtnText = 'Cancel';
                        primaryBtnHandler = () => {
                            isOverlaps = this.checkOverlapRecord(getRegistraionID, updatedEffectiveDate, expectedExpirationDate);
                            if (isOverlaps) {
                                contentText = <p>The attempted date adjustment conflicts with an existing membership. Please review the other memberships for this member and make appropriate adjustments to avoid overlapping dates.</p>;
                                modalPrimaryBtnText = 'Ok';
                                modalScondaryBtnText = undefined;
                                primaryBtnHandler = () => this.setState({ isShowUpdateMembershipModal: false });
                                secondaryBtnHandler = undefined;
                                isUpdatedEffectiveDate = true;
                                needToUpdate[jIndex] = {
                                    buttonNeedToUpdate: isUpdatedEffectiveDate,
                                    isUpdatedEffectiveDate,
                                    isUpdatedExpirationDate: needToUpdate[jIndex] ? needToUpdate[jIndex].isUpdatedExpirationDate : false,
                                    expectedExpirationDate,
                                    contentText,
                                    modalPrimaryBtnText,
                                    modalScondaryBtnText,
                                    primaryBtnHandler,
                                    secondaryBtnHandler,
                                    isOverlaps
                                };
                                this.setState({
                                    needToUpdate: needToUpdate
                                });
                            } else {
                                this.props.actions.UpdateMembership(this.props.personGUID, membership.registrationId, updatedEffectiveDate, expectedExpirationDate, "NESA");
                                this.setState({ isShowUpdateMembershipModal: false });
                            }
                        };
                        secondaryBtnHandler = () => {
                            this.setState({ isShowUpdateMembershipModal: false });
                        };
                        needToUpdate[jIndex] = {
                            buttonNeedToUpdate: isUpdatedEffectiveDate,
                            isUpdatedEffectiveDate,
                            isUpdatedExpirationDate: needToUpdate[jIndex] ? needToUpdate[jIndex].isUpdatedExpirationDate : false,
                            expectedExpirationDate,
                            contentText,
                            modalPrimaryBtnText,
                            modalScondaryBtnText,
                            primaryBtnHandler,
                            secondaryBtnHandler,
                            isOverlaps
                        };
                        this.setState({
                            needToUpdate: needToUpdate
                        });
                    }
                }
                // When effective date is not different
                else {
                    needToUpdate[jIndex] = {
                        buttonNeedToUpdate: needToUpdate[jIndex] ? (needToUpdate[jIndex].isUpdatedExpirationDate || isUpdatedEffectiveDate) : false,
                        isUpdatedEffectiveDate: false,
                        isUpdatedExpirationDate: needToUpdate[jIndex] ? needToUpdate[jIndex].isUpdatedExpirationDate : false,
                        expectedExpirationDate: needToUpdate[jIndex] ? needToUpdate[jIndex].expectedExpirationDate : undefined,
                        contentText: needToUpdate[jIndex] ? needToUpdate[jIndex].contentText : undefined,
                        modalPrimaryBtnText: needToUpdate[jIndex] ? needToUpdate[jIndex].modalPrimaryBtnText : undefined,
                        modalScondaryBtnText: needToUpdate[jIndex] ? needToUpdate[jIndex].modalScondaryBtnText : undefined,
                        primaryBtnHandler: needToUpdate[jIndex] ? needToUpdate[jIndex].primaryBtnHandler : undefined,
                        secondaryBtnHandler: needToUpdate[jIndex] ? needToUpdate[jIndex].secondaryBtnHandler ? needToUpdate[jIndex].secondaryBtnHandler : needToUpdate[jIndex].expectedExpirationDate ? 'No' : undefined : undefined,
                        isOverlaps
                    };
                    this.setState({
                        needToUpdate: needToUpdate
                    });
                }
            }
            // When the 'type' is not 'effectiveDate'
            else {
                // Check if the expiration date is different and has a length of 10
                if (moment(defaultExpirationDate).format('MM-DD-YYYY') != moment(e.target.value).format('MM-DD-YYYY') && e.target.value.length === 10) {
                    updatedExpiryDate = moment(e.target.value).format('MM/DD/YYYY');
                    isUpdatedExpirationDate = true;
                    expectedEffectiveDate = moment(e.target.value).subtract('years', 5).add('days', 1).format('MM/DD/YYYY');
                    expectedExpirationDate = moment(defaultEffectiveDate).add('years', 5).subtract('days', 1).format('MM/DD/YYYY');
                    contentText = <p>The expected expiration date for a {membership.programId == 30 ? '5-Year' : 'Lifetime'} membership that starts on <strong> {moment(membership.effectiveDate).format('MM/DD/YYYY')} </strong> is <strong>{moment(expectedExpirationDate).format('MM/DD/YYYY')}</strong>, Please confirm that you wish to set the expiration date to a non-standard date of <strong>{updatedExpiryDate}</strong></p>;
                    modalPrimaryBtnText = 'Yes';
                    modalScondaryBtnText = 'No';
                    primaryBtnHandler = () => {
                        isOverlaps = this.checkOverlapRecord(getRegistraionID, defaultEffectiveDate, updatedExpiryDate);
                        if (isOverlaps) {
                            contentText = <p>The attempted date adjustment conflicts with an existing membership. Please review the other memberships for this member and make appropriate adjustments to avoid overlapping dates.</p>;
                            modalPrimaryBtnText = 'Ok';
                            modalScondaryBtnText = undefined;
                            primaryBtnHandler = () => this.setState({ isShowUpdateMembershipModal: false });
                            secondaryBtnHandler = undefined;
                            needToUpdate[jIndex] = {
                                buttonNeedToUpdate: isUpdatedExpirationDate,
                                isUpdatedEffectiveDate: needToUpdate[jIndex] ? needToUpdate[jIndex].isUpdatedEffectiveDate : false,
                                isUpdatedExpirationDate,
                                expectedExpirationDate,
                                contentText,
                                modalPrimaryBtnText,
                                modalScondaryBtnText,
                                primaryBtnHandler,
                                secondaryBtnHandler,
                                isOverlaps
                            };
                            this.setState({
                                needToUpdate: needToUpdate
                            });
                        } else {
                            this.props.actions.UpdateMembership(this.props.personGUID, membership.registrationId, membership.effectiveDate, updatedExpiryDate, "NESA");
                            this.setState({ isShowUpdateMembershipModal: false });
                        }
                    };
                    secondaryBtnHandler = () => this.setState({ isShowUpdateMembershipModal: false });
                    isUpdatedExpirationDate = true;
                    needToUpdate[jIndex] = {
                        buttonNeedToUpdate: isUpdatedExpirationDate,
                        isUpdatedEffectiveDate: needToUpdate[jIndex] ? needToUpdate[jIndex].isUpdatedEffectiveDate : false,
                        isUpdatedExpirationDate,
                        expectedExpirationDate,
                        contentText,
                        modalPrimaryBtnText,
                        modalScondaryBtnText,
                        primaryBtnHandler,
                        secondaryBtnHandler,
                        isOverlaps
                    };
                    this.setState({
                        needToUpdate: needToUpdate
                    });
                }
                // When expiration date is not different
                else {
                    needToUpdate[jIndex] = {
                        buttonNeedToUpdate: needToUpdate[jIndex] ? (needToUpdate[jIndex].isUpdatedEffectiveDate || isUpdatedExpirationDate) : false,
                        isUpdatedEffectiveDate: needToUpdate[jIndex] ? needToUpdate[jIndex].isUpdatedEffectiveDate : false,
                        isUpdatedExpirationDate: false,
                        expectedExpirationDate: needToUpdate[jIndex] ? needToUpdate[jIndex].expectedExpirationDate : undefined,
                        contentText: needToUpdate[jIndex] ? needToUpdate[jIndex].contentText : undefined,
                        modalPrimaryBtnText: needToUpdate[jIndex] ? needToUpdate[jIndex].modalPrimaryBtnText : undefined,
                        modalScondaryBtnText: needToUpdate[jIndex] ? needToUpdate[jIndex].modalScondaryBtnText : undefined,
                        primaryBtnHandler: needToUpdate[jIndex] ? needToUpdate[jIndex].primaryBtnHandler : undefined,
                        secondaryBtnHandler: needToUpdate[jIndex] ? needToUpdate[jIndex].secondaryBtnHandler : undefined,
                        isOverlaps
                    };
                    this.setState({
                        needToUpdate: needToUpdate
                    });
                }
            }
        }




        const { getFieldDecorator } = this.props.form;
        return <div>
            <Form onSubmit={(e) => this.handleNESASubmit(jIndex, e, j)}>
                <Row key={jIndex} type="flex" justify="space-between" align="start">
                    <FormItem
                        label=""
                    >
                        {getFieldDecorator('registrationId' + jIndex, {
                            initialValue: j.registrationId,
                            rules: [{ required: false, }],
                        })(
                            <input type='hidden' />
                        )}
                    </FormItem>
                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                        <FormItem
                            label="NESA membership level:"
                        >
                            {getFieldDecorator('nesa_membershiplevel', {
                                initialValue: nesalevel_name ? nesalevel_name : "",
                                rules: [{ required: false, message: 'Enter NESA Membership levels!' }],
                            })(
                                <Select disabled style={{ width: '100%' }} >
                                    {this.renderNesaLevels()}
                                </Select>
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                        <FormItem
                            label="Effective Date:"
                        >
                            {getFieldDecorator('nesa_effective_date' + jIndex, {
                                initialValue: j.effectiveDate ? moment(j.effectiveDate).format('MM/DD/YYYY') : "**/**/****",
                                rules: [
                                    { required: j.isActive, message: 'Enter NESA Membership Effective Date!' },
                                    {
                                        pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20|21|22|23)\d{2}$/,
                                        message: `Please enter correct format MM/DD/YYYY Pattern`
                                    }
                                ],
                            })(

                                // <DatePicker 
                                // disabled={status == 'expiry' ? false : true} />

                                <InputMask
                                    mask="99/99/9999"
                                    disabled={status == 'expiry' || disableDueToActiveLifetime} // According to Sangeeta, only the active and future memberships can be updated. as mentioned in AAG-980.
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={null}
                                    className="ant-input width-100"
                                    onChange={(e) => CheckNeedsToUpdate(j.effectiveDate, jIndex, e, 'effectiveDate', j)}
                                    render={(ref, props) => (
                                        <Input />
                                    )}
                                />

                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                        <FormItem
                            label="Expire Date:"
                        >
                            {getFieldDecorator('nesa_expire_date' + jIndex, {
                                initialValue: j.expireDate ? moment(j.expireDate).format('MM/DD/YYYY') : '',
                                rules: [
                                    { required: j.expireDate && !j.programId == "32", message: 'Enter NESA Membership Expire Date!' },
                                    {
                                        pattern: !j.expireDate && j.programId == "32" ? /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20|21|22|23)\d{2}$/ : '',
                                        message: `Please enter correct format MM/DD/YYYY Pattern`
                                    }
                                ],
                            })(


                            // <DatePicker disabled={status == 'expiry' ? false : true} />

                            <InputMask
                                mask="99/99/9999"
                                disabled={((status == 'expiry' || status == 'inactive') || (j.expireDate == null && j.programId.toString() == '32') || !this.state.forShowingInScoutingAffiliationFrame || disableDueToActiveLifetime ) ? true : false}
                                placeholder='MM/DD/YYYY'
                                alwaysShowMask
                                maskChar={null}
                                className="ant-input width-100"
                                onChange={(e) => CheckNeedsToUpdate(j.expireDate, jIndex, e, 'expiryDate', j)}
                                render={(ref, props) => (
                                    <Input />
                                )}
                            />
                        )}
                    </FormItem>
                </Col>
                <Col className="center" xs={24} sm={24} md={3} lg={3} xl={3} style={{ margin: "25px 0px" }}>
                    <FormItem>
                        {status == 'upgrade' && <Alert message="Upgrade" type="success" showIcon />}
                        {status == 'active' && <Alert message="Current" type="success" showIcon />}
                        {status == 'inactive' && <Alert message="Inactive" type="warning" showIcon />}
                        {status == 'lapsed' && <Alert message="Lapsed" type="warning" showIcon />}
                        {status == 'expiry' && <Alert message="Expired" type="error" showIcon />}
                    </FormItem>
                </Col>
                <Col className="center" xs={24} sm={24} md={5} lg={5} xl={5} style={{ margin: "25px 0px" }}>
                    {/* {(status == 'active' || status == 'lapsed') &&  */}
                    <Row className="flex">
                        {!this.state.forShowingInScoutingAffiliationFrame &&
                                <Col span={12}>
                                    <FormItem>
                                        <Button id="add-sct-aff" className="ant-btn-primary" htmlType="submit" disabled={disableDueToActiveLifetime || (this.state.needToUpdate[jIndex] ? !this.state.needToUpdate[jIndex].buttonNeedToUpdate : true)}> UPDATE </Button>
                                    </FormItem>
                                </Col>
                            }
                            {/* {status == 'active' &&
                            <Col span={12}>
                                <FormItem>
                                    <Button className={this.state.forShowingInScoutingAffiliationFrame ? 'ant-btn-primary' : "ant-btn-primary danger"} loading={this.props.scoutings_adding} onClick={() => {
                                        this.state.forShowingInScoutingAffiliationFrame ? this.props.actions.addScoutings("National Eagle Scout Association") :
                                            this.setState({ visibleExpiryModal: true, registrationId: j.registrationId })
                                    }} > {this.state.forShowingInScoutingAffiliationFrame ? 'ACTIVE' : 'EXPIRE'} </Button>
                                </FormItem>
                            </Col>
                        } */}
                        {(status == 'active' || status == 'inactive' || status == 'upgrade')  && !this.state.forShowingInScoutingAffiliationFrame  &&
                            <Col span={12}>
                                <FormItem>
                                    <Button className="ant-btn-primary danger" loading={this.props.scoutings_adding} disabled={disableDueToActiveLifetime} onClick={() => {
                                            this.props.form.resetFields(['expiry_reason', 'other_reason']);
                                            this.setState({ visibleExpiryModal: true, registrationId: j.registrationId,
                                                personPositionId:j.personPositionId, expireMemberships_DefaultEffDate: j.effectiveDate, expireMemberships_DefaultExpDate: j.expireDate,
                                                expiringMembershipProgramId: j.programId, visibleOtherReason: false })
                                    }} > EXPIRE </Button>
                                </FormItem>
                            </Col>
                        }
                    </Row>
                    {/* } */}
                </Col>
            </Row>
            </Form>

            <div>
                <Modal
                    className="expire-membership-modal"
                    title={
                        <div className="expire-membership-modal-title">
                            <span className="expire-membership-modal-icon">
                                <Icon type="exclamation-circle" theme="filled" />
                            </span>
                            <span>Are you sure you want to expire this membership?</span>
                        </div>
                    }
                    visible={this.state.visibleExpiryModal}
                    closable={false}
                    centered
                    footer={null}
                    width={440}
                >
                    <Form className="expire-membership-modal-form" layout="vertical">
                        <FormItem label="Reason to expire" colon={false} required>
                            {getFieldDecorator("expiry_reason", {
                                initialValue: "",
                            })(
                                <Select
                                    style={{ width: "100%" }}
                                    onChange={this.ReasonChange}
                                >
                                    <option value="Duplicate Membership">Duplicate Membership</option>
                                    {this.state.expiringMembershipProgramId != 32 &&
                                        <option value="Moving from a 5-year membership to Lifetime">Moving from a 5-year membership to Lifetime</option>
                                    }
                                    <option value="Membership Amount Refunded">Membership Amount Refunded</option>
                                    <option value="Others">Others</option>
                                </Select>
                            )}
                        </FormItem>
                        {this.state.visibleOtherReason &&
                            <FormItem label="Other reason" colon={false} required>
                                {getFieldDecorator("other_reason", {
                                    initialValue: "",
                                    rules: [
                                        {
                                            required: true,
                                            message: "Please enter other reason to expire!"
                                        }
                                    ]
                                })(
                                    <Input
                                        type="text"
                                        placeholder="Enter reason"
                                        style={{ width: "100%" }}
                                    />
                                )}
                            </FormItem>
                        }
                        <div className="expire-membership-modal-footer">
                            <Button id="mem-exp-cl-btn" className="expire-membership-modal-cancel-btn" onClick={() => this.closeExpiryMembershipModal()}>Cancel</Button>
                            <Button id="mem-exp-su-btn" type="danger" className="expire-membership-modal-expire-btn"
                                loading={this.props.expiring_membership}
                                onClick={() => this.handleExpiryMembership()}
                            > {this.props.expiring_membership ? 'EXPIRING' : 'EXPIRE'} </Button>
                        </div>
                    </Form>
                </Modal>
            </div>
            <div>
                <Modal
                    // title={<div> <h3> Are you sure you want to expire this membership?  </h3> </div>}
                    visible={this.state.isShowUpdateMembershipModal}
                    onCancel={() => this.setState({ isShowUpdateMembershipModal: false })}
                    footer={
                        null
                    }
                >
                    {this.state.needToUpdate[this.state.membershipIndex] &&
                        <p>
                            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                                <img src={warningAlert} width="40px" height="40px" />
                            </div>
                            {this.state.needToUpdate[this.state.membershipIndex].contentText}
                            <Form className="alumni-ui"
                            // onSubmit={this.handleExpiryMembership}
                            >
                                {/* <Row type="flex" justify="center" align="middle">
                                <div >
                                    <FormItem>
                                        <Button className="CancelNesaMembershipModal" style={{width: '120px', marginRight:'20px'}} onClick={() => this.setState({ isShowUpdateMembershipModal: false })} > {this.state.needToUpdate[this.state.membershipIndex].modalScondaryBtnText} </Button>
                                    </FormItem>
                                </div>
                                <div >
                                    <div className='NESAMembershipActions'>
                                    <FormItem>
                                        <Button type="primary" className="GoToPurchaseNesaMembership"
                                        style={{width: '120px'}}
                                            // loading={this.props.expiring_membership}
                                            onClick={() => this.handleUpdateMembership()}
                                        // htmlType='submit'
                                        > {this.state.needToUpdate[this.state.membershipIndex].modalPrimaryBtnText} </Button>
                                    </FormItem>
                                    </div>
                                </div>
                            </Row> */}
                                <Row type='flex' className='btn-action' style={{ height: '80px' }} justify='space-around'>
                                    <Col xs={23} sm={23} md={18} lg={18} xl={18}>
                                        <Row type='flex' justify='space-around'>
                                            {this.state.needToUpdate[this.state.membershipIndex].modalScondaryBtnText &&
                                                <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                                                    <FormItem>
                                                        <Button className='myprofile-cancel-btn'
                                                            onClick={() => this.state.needToUpdate[this.state.membershipIndex].secondaryBtnHandler()} > {this.state.needToUpdate[this.state.membershipIndex].modalScondaryBtnText} </Button>
                                                    </FormItem>
                                                </Col>
                                            }
                                            <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                                                <FormItem>
                                                    <Button className="save-change-btn" htmlType="submit" type="primary" onClick={() => this.state.needToUpdate[this.state.membershipIndex].primaryBtnHandler()}
                                                    > {this.state.needToUpdate[this.state.membershipIndex].modalPrimaryBtnText} </Button>
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Form>
                        </p>}
                </Modal>
            </div>
        </div>

    }

    renderNESAReg = () => {
        if (this.props.nesa_reg_updating) {
            return <Spin indicator={LoadingIcon} className="loading-state" tip="Updating NESA Membership..." />
        }
        if (this.props.nesa_reg_loading) {
            return <Spin indicator={LoadingIcon} className="loading-state" tip="Loading NESA Membership..." />
        }
        if (this.props.nesa_reg) {
            if (this.props.nesa_reg == "error") {
                return <Alert
                    message="Error"
                    description="Error Occurred while processing request"
                    type="error"
                    showIcon
                />
            }
            if (this.props.nesa_reg.length == 0) {
                return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No NESA Membership" />
            }
            if (this.props.nesa_reg && this.props.nesa_levels) {
                let nesa_reg = this.props.nesa_reg
                nesa_reg.sort(function (a, b) {
                    return b.isActive - a.isActive;
                });
                return nesa_reg.map((j, jIndex) => {
                    let nesalevels = this.props.nesa_levels
                    let nesalevel_name = ''
                    nesalevels.map((k, index) => {
                        if (k.id == j.programId) nesalevel_name = k.name
                    })
                    const { getFieldDecorator } = this.props.form;
                    return this.renderNESAForm(jIndex, nesalevel_name, j)
                })
            }
        }
    }

    // AAG-1378: same active-Lifetime-Membership check as the legacy Add Membership flow
    // (programId 32, effective as of today, no expiration date).
    hasActiveLifetimeMembership = (nesaReg) => {
        if (!Array.isArray(nesaReg)) return false;
        const curDate = new Date();
        return !!nesaReg.find(reg => reg.programId == 32 && moment(curDate).isSameOrAfter(reg.effectiveDate) && reg.expireDate == null);
    }

    render() {
        const { profileinfo, isSuperAlumniAdmin, eagleinfo, nesa_reg } = this.props;

        const hasEagleBorDate = !!(eagleinfo && eagleinfo.eagleBoardReviewDate);
        const hasEagleCertificateDate = !!(eagleinfo && eagleinfo.eagleCertificateDate);

        const hasEagleBorANDCertificateDate =
            hasEagleBorDate && hasEagleCertificateDate;

        const isDeceased =
            profileinfo &&
            profileinfo.profile &&
            profileinfo.profile.isDeceased;

        const canAddNonRevenueMembership =
            isSuperAlumniAdmin &&
            !isDeceased &&
            hasEagleBorANDCertificateDate &&
            !this.hasActiveLifetimeMembership(nesa_reg);

        const missingDates = [];

        if (!hasEagleBorDate) {
            missingDates.push('Eagle Board Review date');
        }

        if (!hasEagleCertificateDate) {
            missingDates.push('Eagle Certificate date');
        }

        return (
            <div>
                {this.renderNESAReg()}

                {isSuperAlumniAdmin && isDeceased && (
                    <div style={{ color: 'red' }}>
                        Constituent is deceased and membership cannot be applied
                    </div>
                )}

                {isSuperAlumniAdmin && !isDeceased && missingDates.length > 0 && (
                    <div style={{ color: 'red' }}>
                        {missingDates.join(' and ')} {missingDates.length === 1 ? 'is' : 'are'} required before membership can be applied.
                    </div>
                )}

                {canAddNonRevenueMembership && (
                    <NESAAddMembership
                        personGUID={this.props.personGUID}
                        nesa_reg={nesa_reg}
                    />
                )}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        nesa_levels_loading: state.nesalevelsreducer.loading,
        nesa_levels: state.nesalevelsreducer.levels,
        nesa_reg_loading: state.nesaregistrationreducer.loading,
        nesa_reg: state.nesaregistrationreducer.reg,
        nesa_reg_updating: state.nesamembershipupdatereducer.loading,
        nesa_reg_updated: state.nesamembershipupdatereducer.updated,
        expiring_membership: state.expiryMembershipReducer.loading,
        scoutings_adding: state.scoutingsaddreducer.loading,
        profileinfo: state.alumniinforeducer.profileinfo,
        isSuperAlumniAdmin: state.isadminreducer.isSuperAlumniAdmin,
        eagleinfo: state.alumnieagleinforeducer.eagleinfo,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) }
}

const NESARegistrations = Form.create()(NESAReg);

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(NESARegistrations);


// WEBPACK FOOTER //
// ./src/components/MaintainAlumni/NESARegistrations.js